export default "__VITE_ASSET__BZPR8_gm__"